import { Dropdown } from '@pandiafi/design-system'
import { Field, FieldProps } from 'formik'
import React from 'react'
import { useTranslation } from 'react-i18next'

import FormFieldWrapper from 'components/FormField'
import { FormValues } from 'views/TerminateContract/TerminateForm/initialValues'
import { useContractTerminationDestinations } from 'views/TerminateContract/hooks/useContractTerminationDestinations'

export const MovingDestinationField = () => {
  const { t } = useTranslation(['common', 'terminateContract'])
  const { contractTerminationDestinations } =
    useContractTerminationDestinations()

  return (
    <Field name="movingDestination">
      {({ field, meta, form }: FieldProps<FormValues['movingDestination']>) => (
        <FormFieldWrapper
          name={field.name}
          label={t('terminateContract:labels.movingDestination')}
          className="min-tablet:max-w-96 mt-8"
          meta={meta}
          labelBold
        >
          <Dropdown
            id={field.name}
            options={contractTerminationDestinations}
            placeholder={t('common:placeholders.select')}
            onChange={(option) =>
              form.setFieldValue(field.name, option ? option.id : '')
            }
            value={contractTerminationDestinations.find(
              (option) => option.id === meta.value
            )}
            allowEmpty
          />
        </FormFieldWrapper>
      )}
    </Field>
  )
}
